
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.632 16.914l-4.75 2.867 1.25-5.406-4.193-3.638 5.533-.467 2.16-5.104 2.16 5.104 5.532.467-4.194 3.638 1.251 5.406m7.882-10.636l-9.082-.77L12.631 0 9.083 8.375 0 9.145l6.884 5.975L4.825 24l7.807-4.712L20.438 24l-2.072-8.88 6.897-5.975z","fill":"#95D7AE"}})])
          )
        }
      }
    